import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar";
import HomePage from "./components/Home";
import ResourcesPage from "./components/ResourcesPage";
import PythonTutorial from "./components/python";
import JavaTutorial from "./components/JavaTutorial";
import CommunityPage from "./components/CommunityPage"; // Import the new CommunityPage component
import GitTutorial from "./components/git&gihub";
import FlaskTutorial from "./components/FlaskTutorial";
import DSATutorial from "./components/Dsa";
import FrontendTutorial from "./components/frontend";
import BackendTutorial from "./components/backend";
import ReactTutorial from "./components/ReactTutorial";
import Roadmaps from "./pages/Roadmaps";
import PythonRoadmap from "./pages/PythonRoadmap";
import JavaRoadmap from "./pages/java";
import CppRoadmap from "./pages/CppRoadmap";
import CompaniesPage from "./components/companies";
import Dsaroadmap from "./pages/dsaroadmap";
import FR from "./pages/FR";
import BR from "./pages/BR";
import FullstackR from "./pages/FullstackR";
import Aiml from "./pages/aiml";
import DS from "./pages/ds";
import DA from "./pages/DA";
import Devops from "./pages/Devops";
import FullStackTutorial from "./components/FullStackTutorial";
import CompanyDetailsPage from "./components/CompanyDetailsPage";
// import ChatBot from "./components/chatbot";
import CareerPath from "./components/CareerPaths";



function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/python" element={<PythonTutorial />} />
          <Route path="/java" element={<JavaTutorial />} />
          <Route path="/git" element={<GitTutorial />} />
          <Route path='/flask' element={<FlaskTutorial/>}/>
          <Route path="/dsa" element={<DSATutorial/>} />
          <Route path="/frontend" element={<FrontendTutorial/>} />
          <Route path="/react" element={<ReactTutorial/>} />
          <Route path="/backend" element={<BackendTutorial/>} />
          <Route path ="fullstack" element={<FullStackTutorial/>} />
          <Route path="/community" element={<CommunityPage />} /> 
          <Route path="/roadmaps" element={<Roadmaps/>} />
          <Route path='/pr' element={<PythonRoadmap/>}/>
          <Route path="/jr" element={<JavaRoadmap/>} />
          <Route path='/cpp'element={<CppRoadmap/>}/>
          <Route path='/cp' element={<CompaniesPage/>}/>
          <Route path='/dsar' element={<Dsaroadmap/>}/>
          <Route path="/fr" element={<FR />} />
          <Route path="/br" element={<BR />} />
          <Route path="/fsr" element={<FullstackR />} />
          <Route path='/aiml' element={<Aiml/>} />
          <Route path='/dsr' element={<DS />} />
          <Route path ='/dar' element={<DA/>} />
          <Route path='/devr' element={<Devops/>} />
          <Route path="/company/:companyId" element={<CompanyDetailsPage/>}/>
          {/* <Route path="/chatbot" element={<ChatBot />} /> */}
          <Route path ='/career-paths' element={<CareerPath/>} />
          
        </Routes>
      </div>
    </Router>
  );
}

export default App;